// AUTO-GENERATED currency dataset — do not edit by hand.
// Active ISO 4217 currencies, curated from the legacy trip-cart catalogue and
// enriched with native symbols (Medusa) + authoritative ISO 4217 minor units.
// Source of truth for the operator currency picker, symbols, per-currency
// decimal precision, and Money value-object validation.

export interface Currency {
  /** ISO 4217 alphabetic code, uppercase. */
  readonly code: string;
  /** English display name, e.g. "United Arab Emirates Dirham". */
  readonly name: string;
  /** Display symbol, e.g. "$", "€", "रू". */
  readonly symbol: string;
  /** Native-script symbol where it differs, else equal to `symbol`. */
  readonly symbolNative: string;
  /** Emoji flag for the issuing country. */
  readonly flag: string;
  /** ISO 3166-1 alpha-2 country code. */
  readonly countryCode: string;
  /** Number of minor-unit decimal places (0, 2, 3, or 4). */
  readonly decimalDigits: number;
}

export const CURRENCIES: readonly Currency[] = [
  {
    code: "AED",
    name: "United Arab Emirates Dirham",
    symbol: "د.إ",
    symbolNative: "د.إ.‏",
    flag: "🇦🇪",
    countryCode: "AE",
    decimalDigits: 2,
  },
  {
    code: "AFN",
    name: "Afghan Afghani",
    symbol: "؋",
    symbolNative: "؋",
    flag: "🇦🇫",
    countryCode: "AF",
    decimalDigits: 2,
  },
  {
    code: "ALL",
    name: "Albanian Lek",
    symbol: "L",
    symbolNative: "Lek",
    flag: "🇦🇱",
    countryCode: "AL",
    decimalDigits: 2,
  },
  {
    code: "AMD",
    name: "Armenian Dram",
    symbol: "֏",
    symbolNative: "դր.",
    flag: "🇦🇲",
    countryCode: "AM",
    decimalDigits: 2,
  },
  {
    code: "ANG",
    name: "Netherlands Antillean Guilder",
    symbol: "ƒ",
    symbolNative: "ƒ",
    flag: "🇨🇼",
    countryCode: "CW",
    decimalDigits: 2,
  },
  {
    code: "AOA",
    name: "Angolan Kwanza",
    symbol: "Kz",
    symbolNative: "Kz",
    flag: "🇦🇴",
    countryCode: "AO",
    decimalDigits: 2,
  },
  {
    code: "ARS",
    name: "Argentine Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇦🇷",
    countryCode: "AR",
    decimalDigits: 2,
  },
  {
    code: "AUD",
    name: "Australian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇦🇺",
    countryCode: "AU",
    decimalDigits: 2,
  },
  {
    code: "AWG",
    name: "Aruban Florin",
    symbol: "ƒ",
    symbolNative: "ƒ",
    flag: "🇦🇼",
    countryCode: "AW",
    decimalDigits: 2,
  },
  {
    code: "AZN",
    name: "Azerbaijani Manat",
    symbol: "₼",
    symbolNative: "ман.",
    flag: "🇦🇿",
    countryCode: "AZ",
    decimalDigits: 2,
  },
  {
    code: "BAM",
    name: "Bosnia and Herzegovina Convertible Mark",
    symbol: "KM",
    symbolNative: "KM",
    flag: "🇧🇦",
    countryCode: "BA",
    decimalDigits: 2,
  },
  {
    code: "BBD",
    name: "Barbadian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇧🇧",
    countryCode: "BB",
    decimalDigits: 2,
  },
  {
    code: "BDT",
    name: "Bangladeshi Taka",
    symbol: "৳",
    symbolNative: "৳",
    flag: "🇧🇩",
    countryCode: "BD",
    decimalDigits: 2,
  },
  {
    code: "BGN",
    name: "Bulgarian Lev",
    symbol: "лв",
    symbolNative: "лв.",
    flag: "🇧🇬",
    countryCode: "BG",
    decimalDigits: 2,
  },
  {
    code: "BHD",
    name: "Bahraini Dinar",
    symbol: ".د.ب",
    symbolNative: "د.ب.‏",
    flag: "🇧🇭",
    countryCode: "BH",
    decimalDigits: 3,
  },
  {
    code: "BIF",
    name: "Burundian Franc",
    symbol: "Fr",
    symbolNative: "FBu",
    flag: "🇧🇮",
    countryCode: "BI",
    decimalDigits: 0,
  },
  {
    code: "BMD",
    name: "Bermudian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇧🇲",
    countryCode: "BM",
    decimalDigits: 2,
  },
  {
    code: "BND",
    name: "Brunei Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇧🇳",
    countryCode: "BN",
    decimalDigits: 2,
  },
  {
    code: "BOB",
    name: "Bolivian Boliviano",
    symbol: "Bs.",
    symbolNative: "Bs",
    flag: "🇧🇴",
    countryCode: "BO",
    decimalDigits: 2,
  },
  {
    code: "BRL",
    name: "Brazilian Real",
    symbol: "R$",
    symbolNative: "R$",
    flag: "🇧🇷",
    countryCode: "BR",
    decimalDigits: 2,
  },
  {
    code: "BSD",
    name: "Bahamian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇧🇸",
    countryCode: "BS",
    decimalDigits: 2,
  },
  {
    code: "BTN",
    name: "Bhutanese Ngultrum",
    symbol: "Nu.",
    symbolNative: "Nu.",
    flag: "🇧🇹",
    countryCode: "BT",
    decimalDigits: 2,
  },
  {
    code: "BWP",
    name: "Botswana Pula",
    symbol: "P",
    symbolNative: "P",
    flag: "🇧🇼",
    countryCode: "BW",
    decimalDigits: 2,
  },
  {
    code: "BYN",
    name: "Belarusian Ruble",
    symbol: "Br",
    symbolNative: "руб.",
    flag: "🇧🇾",
    countryCode: "BY",
    decimalDigits: 2,
  },
  {
    code: "BYR",
    name: "Belarusian Ruble (old)",
    symbol: "Br",
    symbolNative: "Br",
    flag: "🇧🇾",
    countryCode: "BY",
    decimalDigits: 2,
  },
  {
    code: "BZD",
    name: "Belize Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇧🇿",
    countryCode: "BZ",
    decimalDigits: 2,
  },
  {
    code: "CAD",
    name: "Canadian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇨🇦",
    countryCode: "CA",
    decimalDigits: 2,
  },
  {
    code: "CDF",
    name: "Congolese Franc",
    symbol: "Fr",
    symbolNative: "FrCD",
    flag: "🇨🇩",
    countryCode: "CD",
    decimalDigits: 2,
  },
  {
    code: "CHF",
    name: "Swiss Franc",
    symbol: "CHF",
    symbolNative: "CHF",
    flag: "🇨🇭",
    countryCode: "CH",
    decimalDigits: 2,
  },
  {
    code: "CLP",
    name: "Chilean Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇨🇱",
    countryCode: "CL",
    decimalDigits: 0,
  },
  {
    code: "CNY",
    name: "Chinese Yuan",
    symbol: "¥",
    symbolNative: "CN¥",
    flag: "🇨🇳",
    countryCode: "CN",
    decimalDigits: 2,
  },
  {
    code: "COP",
    name: "Colombian Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇨🇴",
    countryCode: "CO",
    decimalDigits: 2,
  },
  {
    code: "CRC",
    name: "Costa Rican Colón",
    symbol: "₡",
    symbolNative: "₡",
    flag: "🇨🇷",
    countryCode: "CR",
    decimalDigits: 2,
  },
  {
    code: "CUC",
    name: "Cuban Convertible Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇨🇺",
    countryCode: "CU",
    decimalDigits: 2,
  },
  {
    code: "CUP",
    name: "Cuban Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇨🇺",
    countryCode: "CU",
    decimalDigits: 2,
  },
  {
    code: "CVE",
    name: "Cape Verdean Escudo",
    symbol: "$",
    symbolNative: "CV$",
    flag: "🇨🇻",
    countryCode: "CV",
    decimalDigits: 2,
  },
  {
    code: "CZK",
    name: "Czech Koruna",
    symbol: "Kč",
    symbolNative: "Kč",
    flag: "🇨🇿",
    countryCode: "CZ",
    decimalDigits: 2,
  },
  {
    code: "DJF",
    name: "Djiboutian Franc",
    symbol: "Fr",
    symbolNative: "Fdj",
    flag: "🇩🇯",
    countryCode: "DJ",
    decimalDigits: 0,
  },
  {
    code: "DKK",
    name: "Danish Krone",
    symbol: "DKK",
    symbolNative: "kr",
    flag: "🇩🇰",
    countryCode: "DK",
    decimalDigits: 2,
  },
  {
    code: "DOP",
    name: "Dominican Peso",
    symbol: "RD$",
    symbolNative: "RD$",
    flag: "🇩🇴",
    countryCode: "DO",
    decimalDigits: 2,
  },
  {
    code: "DZD",
    name: "Algerian Dinar",
    symbol: "د.ج",
    symbolNative: "د.ج.‏",
    flag: "🇩🇿",
    countryCode: "DZ",
    decimalDigits: 2,
  },
  {
    code: "EGP",
    name: "Egyptian Pound",
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    flag: "🇪🇬",
    countryCode: "EG",
    decimalDigits: 2,
  },
  {
    code: "ERN",
    name: "Eritrean Nakfa",
    symbol: "Nfk",
    symbolNative: "Nfk",
    flag: "🇪🇷",
    countryCode: "ER",
    decimalDigits: 2,
  },
  {
    code: "ETB",
    name: "Ethiopian Birr",
    symbol: "Br",
    symbolNative: "Br",
    flag: "🇪🇹",
    countryCode: "ET",
    decimalDigits: 2,
  },
  {
    code: "EUR",
    name: "Euro",
    symbol: "€",
    symbolNative: "€",
    flag: "🇪🇺",
    countryCode: "EU",
    decimalDigits: 2,
  },
  {
    code: "FJD",
    name: "Fijian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇫🇯",
    countryCode: "FJ",
    decimalDigits: 2,
  },
  {
    code: "FKP",
    name: "Falkland Islands Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇫🇰",
    countryCode: "FK",
    decimalDigits: 2,
  },
  {
    code: "GBP",
    name: "Pound Sterling",
    symbol: "£",
    symbolNative: "£",
    flag: "🇬🇧",
    countryCode: "GB",
    decimalDigits: 2,
  },
  {
    code: "GEL",
    name: "Georgian Lari",
    symbol: "₾",
    symbolNative: "GEL",
    flag: "🇬🇪",
    countryCode: "GE",
    decimalDigits: 2,
  },
  {
    code: "GGP",
    name: "Guernsey Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇬🇬",
    countryCode: "GG",
    decimalDigits: 2,
  },
  {
    code: "GHS",
    name: "Ghana Cedi",
    symbol: "₵",
    symbolNative: "GH₵",
    flag: "🇬🇭",
    countryCode: "GH",
    decimalDigits: 2,
  },
  {
    code: "GIP",
    name: "Gibraltar Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇬🇮",
    countryCode: "GI",
    decimalDigits: 2,
  },
  {
    code: "GMD",
    name: "Gambian Dalasi",
    symbol: "D",
    symbolNative: "D",
    flag: "🇬🇲",
    countryCode: "GM",
    decimalDigits: 2,
  },
  {
    code: "GNF",
    name: "Guinean Franc",
    symbol: "Fr",
    symbolNative: "FG",
    flag: "🇬🇳",
    countryCode: "GN",
    decimalDigits: 0,
  },
  {
    code: "GTQ",
    name: "Guatemalan Quetzal",
    symbol: "Q",
    symbolNative: "Q",
    flag: "🇬🇹",
    countryCode: "GT",
    decimalDigits: 2,
  },
  {
    code: "GYD",
    name: "Guyanese Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇬🇾",
    countryCode: "GY",
    decimalDigits: 2,
  },
  {
    code: "HKD",
    name: "Hong Kong Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇭🇰",
    countryCode: "HK",
    decimalDigits: 2,
  },
  {
    code: "HNL",
    name: "Honduran Lempira",
    symbol: "L",
    symbolNative: "L",
    flag: "🇭🇳",
    countryCode: "HN",
    decimalDigits: 2,
  },
  {
    code: "HRK",
    name: "Croatian Kuna",
    symbol: "kn",
    symbolNative: "kn",
    flag: "🇭🇷",
    countryCode: "HR",
    decimalDigits: 2,
  },
  {
    code: "HTG",
    name: "Haitian Gourde",
    symbol: "G",
    symbolNative: "G",
    flag: "🇭🇹",
    countryCode: "HT",
    decimalDigits: 2,
  },
  {
    code: "HUF",
    name: "Hungarian Forint",
    symbol: "Ft",
    symbolNative: "Ft",
    flag: "🇭🇺",
    countryCode: "HU",
    decimalDigits: 2,
  },
  {
    code: "IDR",
    name: "Indonesian Rupiah",
    symbol: "Rp",
    symbolNative: "Rp",
    flag: "🇮🇩",
    countryCode: "ID",
    decimalDigits: 2,
  },
  {
    code: "ILS",
    name: "Israeli New Shekel",
    symbol: "₪",
    symbolNative: "₪",
    flag: "🇮🇱",
    countryCode: "IL",
    decimalDigits: 2,
  },
  {
    code: "IMP",
    name: "Manx Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇮🇲",
    countryCode: "IM",
    decimalDigits: 2,
  },
  {
    code: "INR",
    name: "Indian Rupee",
    symbol: "₹",
    symbolNative: "₹",
    flag: "🇮🇳",
    countryCode: "IN",
    decimalDigits: 2,
  },
  {
    code: "IQD",
    name: "Iraqi Dinar",
    symbol: "ع.د",
    symbolNative: "د.ع.‏",
    flag: "🇮🇶",
    countryCode: "IQ",
    decimalDigits: 3,
  },
  {
    code: "IRR",
    name: "Iranian Rial",
    symbol: "﷼",
    symbolNative: "﷼",
    flag: "🇮🇷",
    countryCode: "IR",
    decimalDigits: 2,
  },
  {
    code: "IRT",
    name: "Iranian Toman",
    symbol: "تومان",
    symbolNative: "تومان",
    flag: "🇮🇷",
    countryCode: "IR",
    decimalDigits: 2,
  },
  {
    code: "ISK",
    name: "Icelandic Króna",
    symbol: "kr.",
    symbolNative: "kr",
    flag: "🇮🇸",
    countryCode: "IS",
    decimalDigits: 0,
  },
  {
    code: "JEP",
    name: "Jersey Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇯🇪",
    countryCode: "JE",
    decimalDigits: 2,
  },
  {
    code: "JMD",
    name: "Jamaican Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇯🇲",
    countryCode: "JM",
    decimalDigits: 2,
  },
  {
    code: "JOD",
    name: "Jordanian Dinar",
    symbol: "د.ا",
    symbolNative: "د.أ.‏",
    flag: "🇯🇴",
    countryCode: "JO",
    decimalDigits: 3,
  },
  {
    code: "JPY",
    name: "Japanese Yen",
    symbol: "¥",
    symbolNative: "￥",
    flag: "🇯🇵",
    countryCode: "JP",
    decimalDigits: 0,
  },
  {
    code: "KES",
    name: "Kenyan Shilling",
    symbol: "KSh",
    symbolNative: "Ksh",
    flag: "🇰🇪",
    countryCode: "KE",
    decimalDigits: 2,
  },
  {
    code: "KGS",
    name: "Kyrgyzstani Som",
    symbol: "сом",
    symbolNative: "сом",
    flag: "🇰🇬",
    countryCode: "KG",
    decimalDigits: 2,
  },
  {
    code: "KHR",
    name: "Cambodian Riel",
    symbol: "៛",
    symbolNative: "៛",
    flag: "🇰🇭",
    countryCode: "KH",
    decimalDigits: 2,
  },
  {
    code: "KMF",
    name: "Comorian Franc",
    symbol: "Fr",
    symbolNative: "FC",
    flag: "🇰🇲",
    countryCode: "KM",
    decimalDigits: 0,
  },
  {
    code: "KPW",
    name: "North Korean Won",
    symbol: "₩",
    symbolNative: "₩",
    flag: "🇰🇵",
    countryCode: "KP",
    decimalDigits: 2,
  },
  {
    code: "KRW",
    name: "South Korean Won",
    symbol: "₩",
    symbolNative: "₩",
    flag: "🇰🇷",
    countryCode: "KR",
    decimalDigits: 0,
  },
  {
    code: "KWD",
    name: "Kuwaiti Dinar",
    symbol: "د.ك",
    symbolNative: "د.ك.‏",
    flag: "🇰🇼",
    countryCode: "KW",
    decimalDigits: 3,
  },
  {
    code: "KYD",
    name: "Cayman Islands Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇰🇾",
    countryCode: "KY",
    decimalDigits: 2,
  },
  {
    code: "KZT",
    name: "Kazakhstani Tenge",
    symbol: "₸",
    symbolNative: "тңг.",
    flag: "🇰🇿",
    countryCode: "KZ",
    decimalDigits: 2,
  },
  {
    code: "LAK",
    name: "Lao Kip",
    symbol: "₭",
    symbolNative: "₭",
    flag: "🇱🇦",
    countryCode: "LA",
    decimalDigits: 2,
  },
  {
    code: "LBP",
    name: "Lebanese Pound",
    symbol: "ل.ل",
    symbolNative: "ل.ل.‏",
    flag: "🇱🇧",
    countryCode: "LB",
    decimalDigits: 2,
  },
  {
    code: "LKR",
    name: "Sri Lankan Rupee",
    symbol: "රු",
    symbolNative: "SL Re",
    flag: "🇱🇰",
    countryCode: "LK",
    decimalDigits: 2,
  },
  {
    code: "LRD",
    name: "Liberian Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇱🇷",
    countryCode: "LR",
    decimalDigits: 2,
  },
  {
    code: "LSL",
    name: "Lesotho Loti",
    symbol: "L",
    symbolNative: "L",
    flag: "🇱🇸",
    countryCode: "LS",
    decimalDigits: 2,
  },
  {
    code: "LYD",
    name: "Libyan Dinar",
    symbol: "ل.د",
    symbolNative: "د.ل.‏",
    flag: "🇱🇾",
    countryCode: "LY",
    decimalDigits: 3,
  },
  {
    code: "MAD",
    name: "Moroccan Dirham",
    symbol: "د.م.",
    symbolNative: "د.م.‏",
    flag: "🇲🇦",
    countryCode: "MA",
    decimalDigits: 2,
  },
  {
    code: "MDL",
    name: "Moldovan Leu",
    symbol: "MDL",
    symbolNative: "MDL",
    flag: "🇲🇩",
    countryCode: "MD",
    decimalDigits: 2,
  },
  {
    code: "MGA",
    name: "Malagasy Ariary",
    symbol: "Ar",
    symbolNative: "MGA",
    flag: "🇲🇬",
    countryCode: "MG",
    decimalDigits: 2,
  },
  {
    code: "MKD",
    name: "Macedonian Denar",
    symbol: "ден",
    symbolNative: "MKD",
    flag: "🇲🇰",
    countryCode: "MK",
    decimalDigits: 2,
  },
  {
    code: "MMK",
    name: "Burmese Kyat",
    symbol: "Ks",
    symbolNative: "K",
    flag: "🇲🇲",
    countryCode: "MM",
    decimalDigits: 2,
  },
  {
    code: "MNT",
    name: "Mongolian Tögrög",
    symbol: "₮",
    symbolNative: "₮",
    flag: "🇲🇳",
    countryCode: "MN",
    decimalDigits: 2,
  },
  {
    code: "MOP",
    name: "Macanese Pataca",
    symbol: "P",
    symbolNative: "MOP$",
    flag: "🇲🇴",
    countryCode: "MO",
    decimalDigits: 2,
  },
  {
    code: "MRO",
    name: "Mauritanian Ouguiya",
    symbol: "UM",
    symbolNative: "UM",
    flag: "🇲🇷",
    countryCode: "MR",
    decimalDigits: 2,
  },
  {
    code: "MUR",
    name: "Mauritian Rupee",
    symbol: "₨",
    symbolNative: "MURs",
    flag: "🇲🇺",
    countryCode: "MU",
    decimalDigits: 2,
  },
  {
    code: "MVR",
    name: "Maldivian Rufiyaa",
    symbol: ".ރ",
    symbolNative: ".ރ",
    flag: "🇲🇻",
    countryCode: "MV",
    decimalDigits: 2,
  },
  {
    code: "MWK",
    name: "Malawian Kwacha",
    symbol: "MK",
    symbolNative: "K",
    flag: "🇲🇼",
    countryCode: "MW",
    decimalDigits: 2,
  },
  {
    code: "MXN",
    name: "Mexican Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇲🇽",
    countryCode: "MX",
    decimalDigits: 2,
  },
  {
    code: "MYR",
    name: "Malaysian Ringgit",
    symbol: "RM",
    symbolNative: "RM",
    flag: "🇲🇾",
    countryCode: "MY",
    decimalDigits: 2,
  },
  {
    code: "MZN",
    name: "Mozambican Metical",
    symbol: "MT",
    symbolNative: "MTn",
    flag: "🇲🇿",
    countryCode: "MZ",
    decimalDigits: 2,
  },
  {
    code: "NAD",
    name: "Namibian Dollar",
    symbol: "$",
    symbolNative: "N$",
    flag: "🇳🇦",
    countryCode: "NA",
    decimalDigits: 2,
  },
  {
    code: "NGN",
    name: "Nigerian Naira",
    symbol: "₦",
    symbolNative: "₦",
    flag: "🇳🇬",
    countryCode: "NG",
    decimalDigits: 2,
  },
  {
    code: "NIO",
    name: "Nicaraguan Córdoba",
    symbol: "C$",
    symbolNative: "C$",
    flag: "🇳🇮",
    countryCode: "NI",
    decimalDigits: 2,
  },
  {
    code: "NOK",
    name: "Norwegian Krone",
    symbol: "kr",
    symbolNative: "kr",
    flag: "🇳🇴",
    countryCode: "NO",
    decimalDigits: 2,
  },
  {
    code: "NPR",
    name: "Nepalese Rupee",
    symbol: "₨",
    symbolNative: "नेरू",
    flag: "🇳🇵",
    countryCode: "NP",
    decimalDigits: 2,
  },
  {
    code: "NZD",
    name: "New Zealand Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇳🇿",
    countryCode: "NZ",
    decimalDigits: 2,
  },
  {
    code: "OMR",
    name: "Omani Rial",
    symbol: "ر.ع.",
    symbolNative: "ر.ع.‏",
    flag: "🇴🇲",
    countryCode: "OM",
    decimalDigits: 3,
  },
  {
    code: "PAB",
    name: "Panamanian Balboa",
    symbol: "B/.",
    symbolNative: "B/.",
    flag: "🇵🇦",
    countryCode: "PA",
    decimalDigits: 2,
  },
  {
    code: "PEN",
    name: "Peruvian Nuevo Sol",
    symbol: "S/.",
    symbolNative: "S/.",
    flag: "🇵🇪",
    countryCode: "PE",
    decimalDigits: 2,
  },
  {
    code: "PGK",
    name: "Papua New Guinean Kina",
    symbol: "K",
    symbolNative: "K",
    flag: "🇵🇬",
    countryCode: "PG",
    decimalDigits: 2,
  },
  {
    code: "PHP",
    name: "Philippine Peso",
    symbol: "₱",
    symbolNative: "₱",
    flag: "🇵🇭",
    countryCode: "PH",
    decimalDigits: 2,
  },
  {
    code: "PKR",
    name: "Pakistani Rupee",
    symbol: "₨",
    symbolNative: "₨",
    flag: "🇵🇰",
    countryCode: "PK",
    decimalDigits: 2,
  },
  {
    code: "PLN",
    name: "Polish Złoty",
    symbol: "zł",
    symbolNative: "zł",
    flag: "🇵🇱",
    countryCode: "PL",
    decimalDigits: 2,
  },
  {
    code: "PRB",
    name: "Transnistrian Ruble",
    symbol: "р.",
    symbolNative: "р.",
    flag: "🇲🇩",
    countryCode: "MD",
    decimalDigits: 2,
  },
  {
    code: "PYG",
    name: "Paraguayan Guaraní",
    symbol: "₲",
    symbolNative: "₲",
    flag: "🇵🇾",
    countryCode: "PY",
    decimalDigits: 0,
  },
  {
    code: "QAR",
    name: "Qatari Riyal",
    symbol: "ر.ق",
    symbolNative: "ر.ق.‏",
    flag: "🇶🇦",
    countryCode: "QA",
    decimalDigits: 2,
  },
  {
    code: "RON",
    name: "Romanian Leu",
    symbol: "lei",
    symbolNative: "RON",
    flag: "🇷🇴",
    countryCode: "RO",
    decimalDigits: 2,
  },
  {
    code: "RSD",
    name: "Serbian Dinar",
    symbol: "дин.",
    symbolNative: "дин.",
    flag: "🇷🇸",
    countryCode: "RS",
    decimalDigits: 2,
  },
  {
    code: "RUB",
    name: "Russian Ruble",
    symbol: "₽",
    symbolNative: "₽.",
    flag: "🇷🇺",
    countryCode: "RU",
    decimalDigits: 2,
  },
  {
    code: "RWF",
    name: "Rwandan Franc",
    symbol: "Fr",
    symbolNative: "FR",
    flag: "🇷🇼",
    countryCode: "RW",
    decimalDigits: 0,
  },
  {
    code: "SAR",
    name: "Saudi Riyal",
    symbol: "ر.س",
    symbolNative: "ر.س.‏",
    flag: "🇸🇦",
    countryCode: "SA",
    decimalDigits: 2,
  },
  {
    code: "SBD",
    name: "Solomon Islands Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇸🇧",
    countryCode: "SB",
    decimalDigits: 2,
  },
  {
    code: "SCR",
    name: "Seychellois Rupee",
    symbol: "₨",
    symbolNative: "₨",
    flag: "🇸🇨",
    countryCode: "SC",
    decimalDigits: 2,
  },
  {
    code: "SDG",
    name: "Sudanese Pound",
    symbol: "ج.س.",
    symbolNative: "SDG",
    flag: "🇸🇩",
    countryCode: "SD",
    decimalDigits: 2,
  },
  {
    code: "SEK",
    name: "Swedish Krona",
    symbol: "kr",
    symbolNative: "kr",
    flag: "🇸🇪",
    countryCode: "SE",
    decimalDigits: 2,
  },
  {
    code: "SGD",
    name: "Singapore Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇸🇬",
    countryCode: "SG",
    decimalDigits: 2,
  },
  {
    code: "SHP",
    name: "Saint Helena Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇸🇭",
    countryCode: "SH",
    decimalDigits: 2,
  },
  {
    code: "SLL",
    name: "Sierra Leonean Leone",
    symbol: "Le",
    symbolNative: "Le",
    flag: "🇸🇱",
    countryCode: "SL",
    decimalDigits: 2,
  },
  {
    code: "SOS",
    name: "Somali Shilling",
    symbol: "Sh",
    symbolNative: "Ssh",
    flag: "🇸🇴",
    countryCode: "SO",
    decimalDigits: 2,
  },
  {
    code: "SRD",
    name: "Surinamese Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇸🇷",
    countryCode: "SR",
    decimalDigits: 2,
  },
  {
    code: "SSP",
    name: "South Sudanese Pound",
    symbol: "£",
    symbolNative: "£",
    flag: "🇸🇸",
    countryCode: "SS",
    decimalDigits: 2,
  },
  {
    code: "STD",
    name: "São Tomé and Príncipe Dobra",
    symbol: "Db",
    symbolNative: "Db",
    flag: "🇸🇹",
    countryCode: "ST",
    decimalDigits: 2,
  },
  {
    code: "SYP",
    name: "Syrian Pound",
    symbol: "ل.س",
    symbolNative: "ل.س.‏",
    flag: "🇸🇾",
    countryCode: "SY",
    decimalDigits: 2,
  },
  {
    code: "SZL",
    name: "Swazi Lilangeni",
    symbol: "L",
    symbolNative: "L",
    flag: "🇸🇿",
    countryCode: "SZ",
    decimalDigits: 2,
  },
  {
    code: "THB",
    name: "Thai Baht",
    symbol: "฿",
    symbolNative: "฿",
    flag: "🇹🇭",
    countryCode: "TH",
    decimalDigits: 2,
  },
  {
    code: "TJS",
    name: "Tajikistani Somoni",
    symbol: "ЅМ",
    symbolNative: "с.",
    flag: "🇹🇯",
    countryCode: "TJ",
    decimalDigits: 2,
  },
  {
    code: "TMT",
    name: "Turkmenistan Manat",
    symbol: "m",
    symbolNative: "m",
    flag: "🇹🇲",
    countryCode: "TM",
    decimalDigits: 2,
  },
  {
    code: "TND",
    name: "Tunisian Dinar",
    symbol: "د.ت",
    symbolNative: "د.ت.‏",
    flag: "🇹🇳",
    countryCode: "TN",
    decimalDigits: 3,
  },
  {
    code: "TOP",
    name: "Tongan Paʻanga",
    symbol: "T$",
    symbolNative: "T$",
    flag: "🇹🇴",
    countryCode: "TO",
    decimalDigits: 2,
  },
  {
    code: "TRY",
    name: "Turkish Lira",
    symbol: "₺",
    symbolNative: "₺",
    flag: "🇹🇷",
    countryCode: "TR",
    decimalDigits: 2,
  },
  {
    code: "TTD",
    name: "Trinidad and Tobago Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇹🇹",
    countryCode: "TT",
    decimalDigits: 2,
  },
  {
    code: "TWD",
    name: "New Taiwan Dollar",
    symbol: "NT$",
    symbolNative: "NT$",
    flag: "🇹🇼",
    countryCode: "TW",
    decimalDigits: 2,
  },
  {
    code: "TZS",
    name: "Tanzanian Shilling",
    symbol: "Sh",
    symbolNative: "TSh",
    flag: "🇹🇿",
    countryCode: "TZ",
    decimalDigits: 2,
  },
  {
    code: "UAH",
    name: "Ukrainian Hryvnia",
    symbol: "₴",
    symbolNative: "₴",
    flag: "🇺🇦",
    countryCode: "UA",
    decimalDigits: 2,
  },
  {
    code: "UGX",
    name: "Ugandan Shilling",
    symbol: "UGX",
    symbolNative: "USh",
    flag: "🇺🇬",
    countryCode: "UG",
    decimalDigits: 0,
  },
  {
    code: "USD",
    name: "United States (US) Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇺🇸",
    countryCode: "US",
    decimalDigits: 2,
  },
  {
    code: "UYU",
    name: "Uruguayan Peso",
    symbol: "$",
    symbolNative: "$",
    flag: "🇺🇾",
    countryCode: "UY",
    decimalDigits: 2,
  },
  {
    code: "UZS",
    name: "Uzbekistani Som",
    symbol: "UZS",
    symbolNative: "UZS",
    flag: "🇺🇿",
    countryCode: "UZ",
    decimalDigits: 2,
  },
  {
    code: "VEF",
    name: "Venezuelan Bolívar",
    symbol: "Bs F",
    symbolNative: "Bs.F.",
    flag: "🇻🇪",
    countryCode: "VE",
    decimalDigits: 2,
  },
  {
    code: "VND",
    name: "Vietnamese Đồng",
    symbol: "₫",
    symbolNative: "₫",
    flag: "🇻🇳",
    countryCode: "VN",
    decimalDigits: 0,
  },
  {
    code: "VUV",
    name: "Vanuatu Vatu",
    symbol: "Vt",
    symbolNative: "Vt",
    flag: "🇻🇺",
    countryCode: "VU",
    decimalDigits: 0,
  },
  {
    code: "WST",
    name: "Samoan Tālā",
    symbol: "T",
    symbolNative: "T",
    flag: "🇼🇸",
    countryCode: "WS",
    decimalDigits: 2,
  },
  {
    code: "XAF",
    name: "Central African CFA Franc",
    symbol: "CFA",
    symbolNative: "FCFA",
    flag: "🇨🇫",
    countryCode: "CF",
    decimalDigits: 0,
  },
  {
    code: "XCD",
    name: "East Caribbean Dollar",
    symbol: "$",
    symbolNative: "$",
    flag: "🇦🇬",
    countryCode: "AG",
    decimalDigits: 2,
  },
  {
    code: "XOF",
    name: "West African CFA Franc",
    symbol: "CFA",
    symbolNative: "CFA",
    flag: "🇧🇯",
    countryCode: "BJ",
    decimalDigits: 0,
  },
  {
    code: "XPF",
    name: "CFP Franc",
    symbol: "Fr",
    symbolNative: "₣",
    flag: "🇵🇫",
    countryCode: "PF",
    decimalDigits: 0,
  },
  {
    code: "YER",
    name: "Yemeni Rial",
    symbol: "﷼",
    symbolNative: "ر.ي.‏",
    flag: "🇾🇪",
    countryCode: "YE",
    decimalDigits: 2,
  },
  {
    code: "ZAR",
    name: "South African Rand",
    symbol: "R",
    symbolNative: "R",
    flag: "🇿🇦",
    countryCode: "ZA",
    decimalDigits: 2,
  },
  {
    code: "ZMW",
    name: "Zambian Kwacha",
    symbol: "ZK",
    symbolNative: "ZK",
    flag: "🇿🇲",
    countryCode: "ZM",
    decimalDigits: 2,
  },
];

export const currencyByCode: Readonly<Record<string, Currency>> = Object.freeze(
  Object.fromEntries(CURRENCIES.map((c) => [c.code, c])),
);

/** All supported ISO 4217 codes (uppercase). */
export const CURRENCY_CODES: readonly string[] = CURRENCIES.map((c) => c.code);

export function isSupportedCurrency(code: string): boolean {
  return Object.prototype.hasOwnProperty.call(
    currencyByCode,
    code.toUpperCase(),
  );
}
